/* eslint-disable no-unused-vars */

import Vue from 'vue'

export const NotificationModule = {
	strict: true, // for developement only
	namespaced: true,
	state: {
		messages: [],
		updates: [],
		unreadMessagesCount: 0,
		unreadUpdatesCount: 0,
	},
	mutations: {
		setAllMessages(state, data) {
			state.messages = data;
		},
		setUnreadMessageCount(state, data) {
			state.unreadMessagesCount = data;
		},
		setAllUpdates(state, data) {
			state.updates = data;
		},
		setUnreadUpdatesCount(state, data) {
			state.unreadUpdatesCount = data;
		},
		setContraventionNotification(state, contraventionId) {
			let unreadCount = 0;
			state.messages.forEach(x => {
				if (x.contraventionId) {
					if (x.contraventionId == contraventionId) {
						x.isRead = 1;
					}
				}
			});
			state.updates.forEach(x => {
				if (x.contraventionId) {
					if (x.contraventionId == contraventionId) {
						x.isRead = 1;
					}
				}
			});

			state.messages.forEach(x => {
				if (x.contraventionId) {
					if (x.contraventionId == contraventionId) {
						x.isRead = 1;
					}
				}
			});

			state.messages.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			state.unreadMessagesCount = unreadCount;

			unreadCount = 0;
			state.updates.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			state.unreadUpdatesCount = unreadCount;
		},
		setUnreadNotification(state, lcrId) {
			let unreadCount = 0;
			state.messages.forEach(x => {
				if (x.lcrId == lcrId) {
					x.isRead = 1;
				}
			});
			state.updates.forEach(x => {
				if (x.lcrId == lcrId) {
					x.isRead = 1;
				}
			});

			state.messages.forEach(x => {
				if (x.lcrId == lcrId) {
					x.isRead = 1;
				}
			});

			state.messages.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			state.unreadMessagesCount = unreadCount;

			unreadCount = 0;
			state.updates.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			state.unreadUpdatesCount = unreadCount;

		},
		setAllUnreadNotification(state, type) {
			let dismissList = [];

			if (type == 'updates') {

				state.updates.forEach(x => {
					x.isRead = 1;
				});

				let unreadCount = 0;
				state.updates.forEach(entry => {
					if (entry.isRead == 0 && !entry.readDate) {
						unreadCount++;
					} else {
						dismissList.push(entry.id);
					}
				});
				state.unreadUpdatesCount = unreadCount;
			}
			if (type == 'messages') {

				state.messages.forEach(x => {
					x.isRead = 1;
				});

				let unreadCount = 0;
				state.messages.forEach(entry => {
					if (entry.isRead == 0 && !entry.readDate) {
						unreadCount++;
					} else {
						dismissList.push(entry);
					}
				});
				state.unreadMessagesCount = unreadCount;
			}

			return dismissList;
		},
		addNewMessage(state, entry) {
			var found = false;
			for (var x = 0; x < state.messages.length; x++) {
				if (entry.id == state.messages[x].id) {
					found = true;
				}
			}
			if (!found) {
				state.messages.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) state.unreadMessagesCount++;
			}
			// if (state.messages.length == 0 || entry.id != state.messages[0].id) {
			// 	state.messages.unshift(entry);
			// 	if (entry.isRead == 0 && !entry.readDate) state.unreadMessagesCount++;
			// }
		},
		addNewUpdate(state, entry) {
			var found = false;
			for (var x = 0; x < state.updates.length; x++) {
				if (entry.id == state.updates[x].id) {
					found = true;
				}
			}
			if (!found) {
				state.updates.unshift(entry);
				if (entry.isRead == 0 && !entry.readDate) state.unreadUpdatesCount++;
			}
			// if (state.updates.length == 0 || entry.id != state.updates[0].id) {
			// }
		}
	},
	actions: {
		async load({
			commit,
			rootState
		}, params = Object()) {
			let res = await Vue.prototype.$http.get(rootState.apiUrl + '/user/notifications').catch(function(error) {});
			commit('setAllMessages', []);
			commit('setAllUpdates', []);
			commit('setUnreadMessageCount', 0);
			commit('setUnreadUpdatesCount', 0);
			if (res) {
				if (res.data) {
					if (res.data.notifications) {
			res.data.notifications.forEach(entry => {
				if (['lcr-new-message', 'lcr-change-request', 'contravention-new-message'].includes(entry.notificationTypeId)) {
					commit('addNewMessage', entry);
				} else {
					commit('addNewUpdate', entry);
				}
			});
						}
					}
			}
		},
		addNotification(context, entry) {
			if (['lcr-new-message', 'lcr-change-request', 'contravention-new-message'].includes(entry.notificationTypeId)) {
				context.commit('addNewMessage', entry);
			} else {
				context.commit('addNewUpdate', entry);
			}
		},
		dismissNotification(context, lcrId) {
			context.commit('setUnreadNotification', lcrId);
		},
		dismissContraventionNotification(context, contraventionId) {
			context.commit('setContraventionNotification', contraventionId);
		},

		async dismissAllNotification(context, type) {
			let dismissList = [];

			if (type == 'messages') {
				context.getters.messages.forEach(entry => {
					if (entry.isRead == 0 && !entry.readDate) {
						entry.isRead = 1;
						dismissList.push(entry.id);
					}
				});
			}
			if (type == 'updates') {
				context.getters.updates.forEach(entry => {
					if (entry.isRead == 0 && !entry.readDate) {
						entry.isRead = 1;
						dismissList.push(entry.id);
					}
				});
			}

			let unreadCount = 0;
			context.state.messages.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			context.state.unreadMessagesCount = unreadCount;

			unreadCount = 0;
			context.state.updates.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			context.state.unreadUpdatesCount = unreadCount;

			await Vue.prototype.$http.post(context.rootState.apiUrl + '/user/notifications/dismiss', {
				notifications: dismissList
			});
		},

		async dismissAllMessageNotification(context, type) {
			let dismissList = [];

				context.getters.messages.forEach(entry => {
					if (entry.isRead == 0 && !entry.readDate) {
						entry.isRead = 1;
						dismissList.push(entry.id);
					}
				});

			let unreadCount = 0;
			context.state.messages.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			context.state.unreadMessagesCount = unreadCount;
			await Vue.prototype.$http.post(context.rootState.apiUrl + '/user/notifications/dismiss-all-messages');
		},


		async dismissAllUpdateNotification(context, type) {
			let dismissList = [];
			if (type == 'updates') {
				context.getters.updates.forEach(entry => {
					if (entry.isRead == 0 && !entry.readDate) {
						entry.isRead = 1;
						dismissList.push(entry.id);
					}
				});
		}

			let unreadCount = 0;
			unreadCount = 0;
			context.state.updates.forEach(entry => {
				if (entry.isRead == 0 && !entry.readDate) unreadCount++;
			});
			context.state.unreadUpdatesCount = unreadCount;

			await Vue.prototype.$http.post(context.rootState.apiUrl + '/user/notifications/dismiss-all-updates');
		},



	},
	getters: {
		messages(state) {
			return state.messages;
		},
		messagesCount(state) {
			return state.messages.length;
		},
		unreadMessagesCount(state) {
			return state.unreadMessagesCount;
		},
		updates(state) {
			return state.updates;
		},
		updatesCount(state) {
			return state.updates.length;
		},
		unreadUpdatesCount(state) {
			return state.unreadUpdatesCount;
		}

	}
}